import { Link, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { FiLogOut, FiUser } from 'react-icons/fi';
import { NAVBAR_CONFIG } from '../config/navbarConfig';
import { useAuth } from '../context/AuthContext';

const LOCATION_ITEMS = [
  {
    key: 'totalps',
    label: 'STATION'
  },
  {
    key: 'totalliu',
    label: 'LIU'
  },
  {
    key: 'totaldcrb',
    label: 'DCRB'
  },
  {
    key: 'totaldcp',
    label: 'DCP'
  },
  {
    key: 'totaldiff',
    label: 'Own PS → Other PS'
  },
  {
    key: 'OTHER_TO_OWN_PS',
    label: 'Other PS → Own PS'
  },
  {
    key: 'other_to_ownLIU',
    label: 'Other PS → Own PS (LIU)'
  },
  {
    key: 'other_to_ownDCRB',
    label: 'Other PS → Own PS (DCRB)'
  }
];


export default function Navbar() {



  const renderLocationMenu = (type, permission) => {
  if (!permission?.enabled) {
    return null;
  }

  return (
    <li className={currentPath === '/characters' && currentType === type ? 'active-menu' : ''}>
      
      <Link
        to={`/characters?type=${type}&loc=${permission.locations[0]}`}
        className="menu-title"
      >
        {type === 'character' && '🛡️ Character'}
        {type === 'employee' && '💼 Employee'}
        {type === 'tenant' && '🏠 Tenant'}
        {type === 'domestic' && '🧹 Domestic'}
      </Link>

      <ul>
        {LOCATION_ITEMS
          .filter(item =>
            permission.locations.includes(item.key)
          )
          .map(item => (
            <li
              key={item.key}
              className={
                currentPath === '/characters' &&
                currentType === type &&
                normLoc === item.key
                  ? 'active-sub'
                  : ''
              }
            >
              <Link
                to={`/characters?type=${type}&loc=${item.key}`}
              >
                {item.label}
              </Link>
            </li>
          ))}
      </ul>

    </li>
  );
};

  const location = useLocation();
  const navigate = useNavigate(); 
  const [searchParams] = useSearchParams();
  const { user, logout } = useAuth();

  const currentPath = location.pathname;
  const currentType = searchParams.get('type') || '';
  const currentLoc = searchParams.get('loc') || '';

  // Normalise short dashboard loc aliases → long navbar loc aliases so
  // `active-sub` highlighting works for both manually-chosen nav links
  // and dashboard drill-down links.
  const LOC_ALIAS = {
    ps:           'totalps',
    liu:          'totalliu',
    dcrb:         'totaldcrb',
    dcp:          'totaldcp',
    remain:       'totalremain',
    own_to_other: 'totaldiff',
    other_to_own: 'OTHER_TO_OWN_PS',
  };
  const normLoc = LOC_ALIAS[currentLoc] || currentLoc;

  const isDashboardActive = currentPath === '/dashboard';
  const isUploadActive = currentPath === '/upload';
  const isCharacterActive = currentPath === '/characters' && (currentType === 'character' || !currentType);
  const isEmployeeActive = currentPath === '/characters' && currentType === 'employee';
  const isTenantActive = currentPath === '/characters' && currentType === 'tenant';
  const isDomesticActive = currentPath === '/characters' && currentType === 'domestic';
  const isComplaintsActive = currentPath === '/characters' && currentType === 'complaint';
  const isPostmortemActive = currentPath === '/characters' && currentType === 'postmortem';

 
  const userType = Number(user?.usertype);

  const permissions =
    NAVBAR_CONFIG[userType] || NAVBAR_CONFIG[1];


  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const displayName = user?.name?.trim() || user?.username || 'User';

  return (
    <div className="nav-wrapper-main">
      {/* ── Header Bar ── */}
      <div className="wrapper-navbar">
        <div className="navbar-logo-left">
          <a href="https://uppolice.gov.in/" target="_blank" rel="noreferrer">
            <img src="/img/UPPOLICE_LOGO.png" alt="UP POLICE LOGO" className="glow-logo" />
          </a>
        </div>
        
        <div className="wrapper-heading">
          <span className="heading-main">Citizen Services Monitoring Portal</span>
          <span className="heading-sub">Developed by Agra Police</span>
        </div>

        <div className="navbar-logo-right">
          <a href="https://agrapolice.in/" target="_blank" rel="noreferrer">
            <img src="/img/agra-logo.png" alt="AGRA POLICE LOGO" className="glow-logo" />
          </a>
        </div>
      </div>

      {/* ── Navigation Menu ── */}
     <nav className="navbar-menu-container">
  <ul className="menu">

    {/* Dashboard */}
    {permissions.dashboard && (
      <li className={isDashboardActive ? 'active-menu' : ''}>
        <Link to="/dashboard" className="menu-title">
          🖥️ Dashboard
        </Link>

        {userType == 5 && (
          <ul>
            <li>
              <Link to="/dashboard?type=character">
                🛡️ Character 
              </Link>
            </li>

            <li>
              <Link to="/dashboard?type=domestic">
                🧹 Domestic
              </Link>
            </li>

            <li>
              <Link to="/dashboard?type=employee">
                💼 Employee
              </Link>
            </li>

            <li>
              <Link to="/dashboard?type=tenant">
                🏠 Tenant 
              </Link>
            </li>

            <li>
              <Link to="/dashboard?type=complaint">
                📢 Complaint
              </Link>
            </li>

            <li>
              <Link to="/dashboard?type=postmortem">
                Postmortem
              </Link>
            </li>
          </ul>
        )}
      </li>
    )}

    {/* Character */}
    {renderLocationMenu(
      'character',
      permissions.character
    )}

    {/* Employee */}
    {renderLocationMenu(
      'employee',
      permissions.employee
    )}

    {/* Tenant */}
    {renderLocationMenu(
      'tenant',
      permissions.tenant
    )}

    {/* Domestic */}
    {renderLocationMenu(
      'domestic',
      permissions.domestic
    )}

    {/* Complaint */}
    {permissions.complaint?.enabled && (
      <li
        className={isComplaintsActive ? 'active-menu' : ''}
      >
        <Link
          to="/characters?type=complaint&loc=totalremain"
          className="menu-title"
        >
          📢 Complaints
        </Link>
      </li>
    )}

    {/* Postmortem */}
    {permissions.postmortem?.enabled && (
      <li
        className={isPostmortemActive ? 'active-menu' : ''}
      >
        <Link
          to="/characters?type=postmortem&loc=totalremain"
          className="menu-title"
        >
          Postmortem
        </Link>
      </li>
    )}

    {/* Upload */}
    {/* {permissions.upload && (
      <li className={isUploadActive ? 'active-menu' : ''}>
        <Link
          to="/upload"
          className="menu-title"
        >
          📤 Uploads
        </Link>

        <ul>
          <li>
            <Link to="/upload?type=character">
              🛡️ Character
            </Link>
          </li>
        </ul>
      </li>
    )} */}

    {user && (
      <li className="menu-user-area">
        <button className="user-menu-icon" type="button" aria-label="Open user menu" aria-haspopup="true">
          <FiUser aria-hidden="true" />
        </button>
        <div className="user-menu-dropdown">
          <div className="user-menu-details">
            <p className="user-detail-line"><span>Name:</span> <strong>{displayName}</strong></p>
            <p className="user-detail-line"><span>Username:</span> <strong>{user.username}</strong></p>
          </div>
          <button onClick={handleLogout} className="logout-btn" title="Log out of system">
            <FiLogOut aria-hidden="true" />
            <span>Logout</span>
          </button>
        </div>
      </li>
    )}

  </ul>
</nav>
    </div>
  );
}
